// extracted by mini-css-extract-plugin
module.exports = {"container":"WhitePanel_container__mS0bt"};